import { formatters } from '@utils/formattersV2';
import { SplineChartWithHeader } from '../../../../../../components/Summary/SplineChartWithHeader';
import { unifiedPlatformColorPalette } from '@utils/unifiedPlatformColorPalette';
import {
  Lci3Report,
  Lci3SalesMetrics,
} from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';
import { reportsToSeriesData } from '../../../../utils';

type IncrementalSalesLiftSplineChartProps = {
  reports: Lci3Report[];
  salesMetrics: Lci3SalesMetrics;
};

export const IncrementalSalesLiftSplineChart = (
  props: IncrementalSalesLiftSplineChartProps
) => {
  const incrementalSalesLiftSplineData = reportsToSeriesData({
    reports: props.reports,
    type: 'sales',
    field: 'incrementalSalesLift',
  });

  return (
    <SplineChartWithHeader
      data={incrementalSalesLiftSplineData}
      color={unifiedPlatformColorPalette.chartLightGreen}
      formatter={formatters.lift}
      yAxisLabelFormatter={value =>
        formatters.percentage(value, { decimals: 0 })
      }
      title="Incremental Sales Lift"
      differenceType="lift"
      confidenceLevel={props.salesMetrics.confidenceLevel.total ?? undefined}
      data-testid="incremental-sales-lift-chart"
    />
  );
};
